/** A site's icon, by Google's favicon service, for an address; null when it isn't one. */
export const favicon = (url: string) => {
  try {
    return `https://www.google.com/s2/favicons?domain=${new URL(url).hostname}&sz=64`;
  } catch {
    return null; // not a URL: the letter tile stands in
  }
};

/** A site's name as a person reads it: its host without the "www.". */
export const siteName = (site: string) => site.replace(/^www\./, "");

/** The address when it opens a web page, so a source's link is never `javascript:` or the like. */
export const webAddress = (url: string) => (/^https?:\/\//i.test(url) ? url : undefined);
